import styled, { css } from 'styled-components';

export const Container = styled.div<{ $isVisible: boolean }>`
  display: block;
  align-self: flex-end;
  padding-bottom: 8em;
  padding-right: 20px;
  pointer-events: auto;
  justify-content: flex-end;
  position: absolute;
  height: fit-content;
  bottom: 0;
  right: 0;

  opacity: 1;
  visibility: visible;

  transition:
    visibility 250ms,
    opacity 250ms;

  ${({ $isVisible }) =>
    !$isVisible &&
    css`
      opacity: 0;
      visibility: hidden;
    `}
`;

export const Button = styled.button`
  cursor: pointer;
  font: inherit;
  display: flex;
  height: 100%;
`;

export const MenuItem = styled.li.attrs({ tabIndex: -1 })`
  list-style-type: none;
  user-select: none;
`;
